'use client'
import { DeleteOutlined, VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'
import { IconButton, Stack, Tooltip } from '@mui/material'
import { BORDER_GREY } from '@/constants/colors'
import { memo } from 'react'
import { useTranslations } from 'next-intl'

type FieldControlsProps = {
  id: string
  label: string
  isDefault: boolean
  isHidden: boolean
  isDesktop: boolean
  onControlClick: (id: string, label: string, isDelete: boolean) => void
}

const FieldControls = ({ id, label, isDefault, isHidden, isDesktop, onControlClick }: FieldControlsProps) => {
  const t = useTranslations('HOMEPAGE')

  return (
    <Tooltip title={isDefault ? (isHidden ? t('SHOW') : t('HIDE')) : t('DELETE')}>
      <IconButton
        size="small"
        color="primary"
        sx={{
          border: `1px solid ${BORDER_GREY}`,
          display: {
            xs: isDesktop ? 'none' : 'flex',
            sm: isDesktop ? 'flex' : 'none',
          },
          flexShrink: 0,
        }}
        onClick={() => onControlClick(id, label, !isDefault)}
      >
        {isDefault ? (
          <>{isHidden ? <VisibilityOffOutlined fontSize="small" /> : <VisibilityOutlined fontSize="small" />}</>
        ) : (
          <DeleteOutlined fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default memo(FieldControls)
